import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { API_SETTINGS } from './API_SETTINGS';
import { BillingAddress } from '../models/payment/PaymentRequest';
import { PaymentResponse } from '../models/payment/PaymentResponse';
import { CryptoService } from '../services/crypto.service';
import { Discount } from '../models/payment/Discount';
import { StorageService } from '../services/storageService.service';
import { BuyRequestResponse } from '../models/payment/BuyRequestResponse';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const apiUrl = API_SETTINGS.API_URL + 'Payment';

@Injectable({
  providedIn: 'root'
})
export class ApiPaymentService {

  constructor(private http: HttpClient,
    private cryptoService: CryptoService,
    public storageService: StorageService) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getPrice(productId: number, billingAddress: BillingAddress): Observable<number> {
    const url = apiUrl + '/Price/' + productId;
    return this.http.post<number>(url, billingAddress, httpOptions).pipe(
      catchError(this.handleError<number>('getPrice'))
    )
  }

  processPayment(customerId: number, productId: number, token: string, billingAddress: BillingAddress): Observable<PaymentResponse> {
    const url = apiUrl + '/Process/' + customerId + '/' + productId + '/' + token + '/' + this.cryptoService.decryptData(this.storageService.getItem("login_email"));
    return this.http.post<PaymentResponse>(url, billingAddress, httpOptions).pipe(
      catchError(this.handleError<PaymentResponse>('processPayment'))
    )
  }

  processBPPayment(customerId: number, productId: number, token: string, billingAddress: BillingAddress): Observable<PaymentResponse> {
    const url = apiUrl + '/BPProcess/' + customerId + '/' + productId + '/' + token + '/' + this.cryptoService.decryptData(this.storageService.getItem("login_email"));
    return this.http.post<PaymentResponse>(url, billingAddress, httpOptions).pipe(
      catchError(this.handleError<PaymentResponse>('processBPPayment'))
    )
  }

  processBuyRequest(customerId: number, productId: number): Observable<BuyRequestResponse> {
    const url = apiUrl + '/BuyRequestProcess/' + customerId + '/' + productId + '/' + this.cryptoService.decryptData(this.storageService.getItem("login_email"));
    return this.http.post<BuyRequestResponse>(url, "", httpOptions).pipe(
      catchError(this.handleError<BuyRequestResponse>('buyRequestResponse'))
    )
  }
}